import { Theme, Font } from '@oneamerica/dxp-ui-components';
import ColorConstants from '../../constants/ColorConstants';
import BreakpointConstants from '../../constants/BreakpointConstants';

export default (width: number) =>
  Theme.Responsive.create({
    cardShadow: {
      borderRadius: 5,
      shadowRadius: 6,
      backgroundColor: Theme.Color.background,
      shadowColor: Theme.Color.backgroundShadow,
      shadowOffset: { width: 0, height: 3 },
      paddingHorizontal: Theme.Metrics.small,
      paddingVertical: Theme.Metrics.small,
      flex: 1,
    },
    cardHeader: {
      marginHorizontal: -Theme.Metrics.medium,
      marginTop: Theme.Metrics.small,
      paddingHorizontal: Theme.Metrics.medium,
      borderRadius: 4,
    },
    cardHeaderTitle: { color: Theme.Color.oaBlue },
    tableTitle: {
      color: ColorConstants.iron,
      fontSize: 20,
      fontFamily: Font.regular.fontFamily,
      fontWeight: '700',
    },
    placeholderText: {
      color: ColorConstants.iron,
      fontSize: 15,
      fontFamily: Font.regular.fontFamily,
      fontWeight: '400',
      marginTop: 15,
    },
    notesTitle: {
      color: ColorConstants.iron,
      fontSize: 16,
      fontFamily: Font.regular.fontFamily,
      fontWeight: '700',
    },
    bulletListStyle: {
      marginTop: BreakpointConstants.isLG(width) ? 15 : 0,
      fontSize: 14,
      fontWeight: '400',
      fontFamily: 'Robto-Regular',
    },
    topMargin: {
      marginTop: 25,
    },
    noTopMargin: {
      marginTop: 0,
    },
    cardPadding: {
      paddingTop: BreakpointConstants.isLG(width) ? 48 : 25,
      paddingBottom: BreakpointConstants.isLG(width) ? 36 : 25,
      paddingHorizontal: BreakpointConstants.isLG(width) ? 32 : 20,
    },
    buttonWidth: {
      width: BreakpointConstants.isMD(width) ? 'auto' : '290px',
    },
    buttonAlignRight: {
      marginLeft: 'auto',
    },
    buttonSpaceLeft: {
      marginLeft: 20,
    },
    buttonCancelLeft: {
      marginLeft: 0,
      marginTop: 0,
    },
    buttonKeepEditingMD: {
      marginLeft: '15px',
    },
    buttonKeepEditing: {
      marginLeft: '10px',
    },
    buttonWidthModal: {
      width: BreakpointConstants.isMD(width) ? '156px' : 'auto',
    },
    smModalSize: {
      margin: BreakpointConstants.isMD(width) ? '365' : 'auto',
      maxHeight: BreakpointConstants.isMD(width) ? '' : '190px',
      maxWidth: BreakpointConstants.isMD(width) ? '' : '90%',
    },
    pendingModalSize: {
      margin: BreakpointConstants.isMD(width) ? '365' : 'auto',
      maxHeight: BreakpointConstants.isMD(width) ? '' : '70%',
      maxWidth: BreakpointConstants.isMD(width) ? '' : '90%',
      flexBasis: 'auto',
      height: 'auto',
      flexShrink: 0,
      flexGrow: 0,
    },
    modalTitle: {
      fontFamily: Font.regular.fontFamily,
      fontSize: 20,
      fontWeight: '400',
      zIndex: -1,
    },
    buttonTop: {
      marginLeft: 0,
      marginTop: 10,
      alignSelf: 'center',
      alignItems: 'center',
    },
    buttonFlexDirection: {
      flexDirection: BreakpointConstants.isMD(width) ? 'row' : 'column',
    },
    showLg: {
      display: BreakpointConstants.isLG(width) ? 'flex' : 'none',
    },
    hideLg: {
      display: BreakpointConstants.isLG(width) ? 'none' : 'flex',
    },
    accordionBg: {
      backgroundColor: '#F3F9FE',
      borderLeftColor: ColorConstants.darkBlue,
      borderLeftWidth: 4,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      fontWeight: '700',
      color: ColorConstants.iron,
      paddingTop: 16,
      paddingBottom: 16,
      paddingRight: 20,
      paddingLeft: 24,
    },
    row: {
      flex: 1,
      flexDirection: 'row',
    },
    pieChartColumn: {
      // minWidth: '50%',
      display: 'flex',
      alignItems: 'center',
      flexGrow: 0,
      flexShrink: 1,
      height: 'auto',
    },
    piechartHeading: {
      fontSize: 16,
      fontWeight: '700',
      paddingTop: 25,
      color: Theme.Color.black,
      fontFamily: Font.regular.fontFamily,
      lineHeight: 20,
    },
    horizontalDivider: {
      backgroundColor: ColorConstants.grey200,
      height: 1,
      width: '100%',
    },
    pdfLink: {
      color: ColorConstants.oaBlueTint,
      //marginTop: 8,
      fontFamily: Font.regular.fontFamily,
      fontSize: 15,
      fontWeight: '700',
      //@ts-ignore
      cursor: 'pointer',
      //textTransform: 'uppercase',
      marginLeft: 5,
    },
    firstParagraph: {
      lineHeight: 17.58,
      marginTop: 8,
    },
    linkContactUs: {
      color: ColorConstants.oaBlueTint,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      fontWeight: '500',
      //@ts-ignore
      display: 'inline-flex',
    },
    linkContactUsFocus: {
      textDecorationLine: 'underline',
      textDecorationColor: Theme.Color.linkFocus,
    },
    linkContactUsHover: {
      color: ColorConstants.oaBlueTint,
      fontSize: 15,
      fontFamily: Font.medium.fontFamily,
      fontWeight: '500',
    },
  })();
